import { render, staticRenderFns } from "./Objetivos.vue?vue&type=template&id=bd70beaa&scoped=true&"
import script from "./Objetivos.vue?vue&type=script&lang=js&"
export * from "./Objetivos.vue?vue&type=script&lang=js&"
import style0 from "./Objetivos.vue?vue&type=style&index=0&id=bd70beaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd70beaa",
  null
  
)

export default component.exports